import { validateBranchSubmission } from './branch-validator'
import { IntegrationError } from './integration-error'

export function validateIntegrationRequirements(
  integrations: any[],
  datasetRows: any[],
): IntegrationError[] {
  const errors: IntegrationError[] = []

  integrations.forEach(i => {
    switch (i.slug) {
      // eventually there will be validation methods for other integrations, currently just validating branch submissions
      case 'branch':
        validateBranchSubmission(i, datasetRows, errors)
        break
      default:
        break
    }
  })
  return errors
}
